export function PasswordFormatValidate(val) {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$&()-`.+,/"\d]{8,20}$/g;
  return regex.test(val);
}

export function MobileFormatValidate(val) {
  const regex = /^[0-9()-+]{0,20}$/g;
  const valid = regex.test(val);
  return valid;
}

export function EmailValidate(val) {
  const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  const valid = regex.test(val);
  return valid;
}
